module.exports = __webpack_public_path__ + "img/xiao5.4bf9ba40.jpg";